import { WidgetTitle } from '@elfsight/widget-ui';

interface TitleProps {
  textColor: string;
  title?: string;
  caption?: string;
  isMobile?: boolean;
}

export const Title = ({ textColor, isMobile, title, caption }: TitleProps) => {
  return (
    <WidgetTitle
      enabledTextBalance={false}
      enabled
      alignment="left"
      titleColor={textColor}
      title={title || ''}
      titleTextStyle={{
        fontSize: isMobile ? 24 : 28,
        fontWeight: 'bold'
      }}
      caption={caption || ''}
      captionColor={textColor}
      captionTextStyle={{
        fontSize: isMobile ? 16 : 18,
        fontWeight: 'normal'
      }}
    />
  );
};
